module.exports = __webpack_public_path__ + "static/media/facebook.3c0ca882.svg";